import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '')).get('session_id');

    if (!sessionId) {
      navigate('/admin/login', { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          {},
          { headers: { 'X-Session-ID': sessionId }, withCredentials: true }
        );
        window.history.replaceState(null, '', '/admin/referral-interest');
        navigate('/admin/referral-interest', { replace: true });
      } catch (err) {
        const msg = err?.response?.status === 403
          ? 'Access is restricted to the administrator account.'
          : 'Sign-in failed. Please try again.';
        toast.error(msg);
        navigate('/admin/login', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-200" data-testid="auth-callback">
      <p className="text-forest-700 font-medium">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
